import React from 'react';
import './index.scss';

// import InputIcon from 'assets/SP_icon_01.png';
// import ConfIcon from 'assets/SP_icon_02.png';
// import ThanksIcon from 'assets/SP_icon_03.png';
// import AddInputIcon from 'assets/SP_icon_04.png';
// import AddConfIcon from 'assets/SP_icon_05.png';
// import AddThanksIcon from 'assets/SP_icon_06.png';

import { INPUT_URL, CONF_URL, THANKS_URL, ADD_INPUT_URL, ADD_CONF_URL, ADD_THANKS_URL } from 'utils/constant';
const dir = require.context('assets/');
const InputIcon = dir(`./SP_icon_01.png`);
const ConfIcon = dir(`./SP_icon_02.png`);
const ThanksIcon = dir(`./SP_icon_03.png`);
const AddInputIcon = dir(`./SP_icon_04.png`);
const AddConfIcon = dir(`./SP_icon_05.png`);
const AddThanksIcon = dir(`./SP_icon_06.png`);

const SpProgress = ({ path })=>{

  const SpProgressImage = ({ img }) => (
    <div className="img-area">
      <img className="img" src={img} alt={img} />
    </div>
  );
  const ProgressPattern = {
    [INPUT_URL]: <SpProgressImage img={InputIcon} />,
    [CONF_URL]: <SpProgressImage img={ConfIcon} />,
    [THANKS_URL]: <SpProgressImage img={ThanksIcon} />,
    [ADD_INPUT_URL]: <SpProgressImage img={AddInputIcon} />,
    [ADD_CONF_URL]: <SpProgressImage img={AddConfIcon} />,
    [ADD_THANKS_URL]: <SpProgressImage img={AddThanksIcon} />,
  };
  return(
    <div className="SpProgress" id="SpProgress">
      <div className="sp-progress-wrapper">
        {ProgressPattern[path]}
      </div>
    </div>
  );
};

export default SpProgress;